"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var ColorUtility =
/*#__PURE__*/
function () {
  function ColorUtility() {
    _classCallCheck(this, ColorUtility);
  }

  _createClass(ColorUtility, null, [{
    key: "hexToRGB",
    // credit: https://stackoverflow.com/a/39077686
    // This will accept three character shorthand hex colors as well as the standard six character format.
    value: function hexToRGB(hexColor) {
      return hexColor.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, function (m, r, g, b) {
        return '#' + r + r + g + g + b + b;
      }).substring(1).match(/.{2}/g).map(function (x) {
        return parseInt(x, 16);
      });
    }
  }, {
    key: "rgbToHex",
    value: function rgbToHex(rgb) {
      var nToHex = function nToHex(n) {
        var hex = parseInt(n, 10).toString(16);
        return hex.length === 1 ? '0' + hex : hex;
      };

      return '#' + nToHex(rgb[0]) + nToHex(rgb[1]) + nToHex(rgb[2]);
    }
  }, {
    key: "getTextColorFromRGB",
    value: function getTextColorFromRGB(backgroundRGB) {
      // Standard contrast calculation based on the Y component of the YIQ color space.  Libby uses the same default Luma threshold.
      // https://github.com/bksh/dewey-js/blob/ebb7189241c5eade8000776d97cd5451bf643e3d/src/app/base/cover-guru.js#L10
      // https://en.wikipedia.org/wiki/YIQ#From_RGB_to_YIQ
      var LUMA_THRESHOLD_YIQ = 190;
      return (backgroundRGB[0] * 299 + backgroundRGB[1] * 587 + backgroundRGB[2] * 114) / 1000 > LUMA_THRESHOLD_YIQ ? '#000000' : '#ffffff';
    }
  }, {
    key: "getTextColorFromHex",
    value: function getTextColorFromHex(backgroundHex) {
      var rgb = ColorUtility.hexToRGB(backgroundHex);
      return ColorUtility.getTextColorFromRGB(rgb);
    }
  }, {
    key: "shadeColorHex",
    value: function shadeColorHex(hexColor, percent) {
      var rgb = ColorUtility.hexToRGB(hexColor);
      var shadedRGB = ColorUtility.shadeColor(rgb, percent);
      return ColorUtility.rgbToHex(shadedRGB);
    }
  }, {
    key: "shadeColor",
    value: function shadeColor(rgb, percent) {
      percent = Math.abs(percent);
      var hsl = ColorUtility.rgbToHsl(rgb[0], rgb[1], rgb[2]);
      var l = hsl[2];

      if (l >= 0.5) {
        percent *= -1;
      }

      l = l + percent;
      hsl[2] = l;
      return ColorUtility.hslToRgb(hsl[0], hsl[1], hsl[2]);
    }
    /**
     * Credit: taken from https://stackoverflow.com/a/9493060
     *
     * Converts an HSL color value to RGB. Conversion formula
     * adapted from http://en.wikipedia.org/wiki/HSL_color_space.
     * Assumes h, s, and l are contained in the set [0, 1] and
     * returns r, g, and b in the set [0, 255].
     *
     * @param   {number}  h       The hue
     * @param   {number}  s       The saturation
     * @param   {number}  l       The lightness
     * @return  {Array}           The RGB representation
     */

  }, {
    key: "hslToRgb",
    value: function hslToRgb(h, s, l) {
      var r, g, b;

      if (s === 0) {
        r = g = b = l; // achromatic
      } else {
        var hue2rgb = function hue2rgb(p, q, t) {
          if (t < 0) {
            t += 1;
          }

          if (t > 1) {
            t -= 1;
          }

          if (t < 1 / 6) {
            return p + (q - p) * 6 * t;
          }

          if (t < 1 / 2) {
            return q;
          }

          if (t < 2 / 3) {
            return p + (q - p) * (2 / 3 - t) * 6;
          }

          return p;
        };

        var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
        var p = 2 * l - q;
        r = hue2rgb(p, q, h + 1 / 3);
        g = hue2rgb(p, q, h);
        b = hue2rgb(p, q, h - 1 / 3);
      }

      return [Math.round(r * 255), Math.round(g * 255), Math.round(b * 255)];
    }
    /**
     * Credit: taken from https://stackoverflow.com/a/9493060
     *
     * Converts an RGB color value to HSL. Conversion formula
     * adapted from http://en.wikipedia.org/wiki/HSL_color_space.
     * Assumes r, g, and b are contained in the set [0, 255] and
     * returns h, s, and l in the set [0, 1].
     *
     * @param   {number}  r       The red color value
     * @param   {number}  g       The green color value
     * @param   {number}  b       The blue color value
     * @return  {Array}           The HSL representation
     */

  }, {
    key: "rgbToHsl",
    value: function rgbToHsl(r, g, b) {
      r = r / 255;
      g = g / 255;
      b = b / 255;
      var max = Math.max(r, g, b);
      var min = Math.min(r, g, b);
      var h,
          s,
          l = (max + min) / 2;

      if (max === min) {
        h = s = 0; // achromatic
      } else {
        var d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);

        switch (max) {
          case r:
            h = (g - b) / d + (g < b ? 6 : 0);
            break;

          case g:
            h = (b - r) / d + 2;
            break;

          case b:
            h = (r - g) / d + 4;
            break;
        }

        h /= 6;
      }

      return [h, s, l];
    }
  }, {
    key: "highContrastBlue",
    // see _vars.scss for the corresponding css color vars
    //
    get: function get() {
      return '#0000FF';
    }
  }, {
    key: "highContrastBlueHover",
    get: function get() {
      return '#0000F5';
    }
  }, {
    key: "highContrastYellow",
    get: function get() {
      return '#FFFF00';
    }
  }, {
    key: "highContrastYellowHover",
    get: function get() {
      return '#F5E600';
    }
  }]);

  return ColorUtility;
}();

exports["default"] = ColorUtility;